import { Injectable } from '@angular/core';
import { EndpointsService } from './endpoints.service';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  private _categories = <any>[];

  set categories(categories: any) {
    this._categories = categories;
  }

  constructor(
    private httpService: HttpService,
    private endpoints: EndpointsService
  ) { }

  fetch() {
    return this.httpService.get(this.endpoints.categories);
  }

  categoryName(categoryId: string) {
    // Search for the category name in the categories array
    const category = this._categories.find((category: any) => category.id === categoryId);
    if (!category) {
      return '';
    }
    return category.name;
  }

}
